import { gql } from '@/__generated__';

export const productListDocument = gql(/* GraphQL */ `
  query ProductList(
    $where: ProductWhereInput
    $skip: Int
    $take: Int
    $orderBy: [ProductOrderByWithRelationInput!]
  ) {
    products(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      code
      name
      description
      price
      active
      canRemove
      createdAt
      updatedAt
    }
  }
`);

export const productLivesDocument = gql(/* GraphQL */ `
  query ProductLives(
    $where: LiveWhereInput
    $skip: Int
    $take: Int
    $orderBy: [LiveOrderByWithRelationInput!]
  ) {
    lives(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      name
    }
  }
`);

export const productsDocument = gql(/* GraphQL */ `
  query Products(
    $where: ProductWhereInput
    $skip: Int
    $take: Int
    $orderBy: [ProductOrderByWithRelationInput!]
  ) {
    products(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      code
      name
      description
      price
      active
      canRemove
      live {
        id
        name
        description
      }
      reservations {
        id
        name
      }
      _count {
        variants
      }
      createdAt
      updatedAt
    }
  }
`);

export const productsCodeDocument = gql(/* GraphQL */ `
  query ProductsCode($where: ProductWhereInput) {
    products(where: $where) {
      id
      code
      active
      price
    }
  }
`);

export const productsTabletDocument = gql(/* GraphQL */ `
  query ProductsTablet(
    $where: ProductWhereInput
    $orderBy: [ProductOrderByWithRelationInput!]
    $take: Int
  ) {
    products(where: $where, orderBy: $orderBy, take: $take) {
      id
      code
      name
      description
      price
    }
  }
`);

export const productTabletDocument = gql(/* GraphQL */ `
  query ProductTablet(
    $where: ProductWhereUniqueInput!
    $variantsOrdersBy: [ProductVariantOrderByWithRelationInput!]
  ) {
    product(where: $where) {
      id
      reservations {
        id
      }
      variants(orderBy: $variantsOrdersBy) {
        id
        stock
        attributes {
          id
          name
          value
        }
        lines {
          id
          price
        }
        reservations {
          id
        }
      }
    }
  }
`);

export const productTabletSummaryDocument = gql(/* GraphQL */ `
  query ProductTabletSummary(
    $where: ProductWhereUniqueInput!
    $variantsOrderBy: [ProductVariantOrderByWithRelationInput!]
  ) {
    productTabletSummary(where: $where, variantsOrderBy: $variantsOrderBy) {
      reservationsCount
      recentLinesCount
      prevLinesCount
      secondsSinceLastSale
      variants {
        id
        stock
        attributes {
          id
          name
          value
        }
        linesCount
        linesSum
        reservationsCount
      }
    }
  }
`);
